import { loadingSlice } from "@viz/slices/LoadingSlice.slice";
import { SvgSpinner } from "./SvgSpinner";

export const SpinningOverlay = (props: {
  zIndex?: number
}) => {
  const { zIndex = 1000 } = props;
  const loadingItems = loadingSlice.useSelector((s) => s.items);
  const item = loadingItems.length > 0 ? loadingItems[loadingItems.length - 1] : undefined;

  return <SvgSpinner visible={loadingItems.length > 0} title={item?.title} backgroundColor={item?.backgroundColor} zIndex={zIndex} />;
};
